import anime from 'animejs';
import {Component} from 'lowkey-component';

export class Collapse extends Component {
  isOpen = false;
  content: Component<HTMLDivElement> | null = null;
  contentHeight = 0;
  plus: HTMLDivElement | undefined | null = undefined;
  public trigger: Component | null = null;

  didMount() {
    const {trigger = '', content = ''} = this.element?.dataset || {};

    // this.trigger = new Component(this.element?.querySelector(trigger) as HTMLDivElement);
    // trigger && this.trigger.mount();
    this.trigger = this.select(trigger);
    this.content = this.select(content);
    this.contentHeight = this.content?.element?.clientHeight ?? 0;

    this.trigger?.on('click', (e) => {
      if (this.element?.classList.contains('open')) {
        this.slideUp();
      } else {
        this.slideDown();
      }
    });

    this.plus =
      this.trigger?.element?.querySelector('.a-plus') ||
      this.trigger?.element?.querySelector('.a-icon-plus');

    this.content?.on('click', () => {
      // this.isOpen && this.slideUp();
    });
  }

  getHeight() {
    const clone = this.content?.element?.cloneNode(true) as HTMLElement;
    clone && (clone.style.cssText = 'visibility: hidden; height: auto;');
    const height =
      this.content?.element?.parentElement?.appendChild(clone).clientHeight;
    this.content?.element?.parentElement?.removeChild(clone);
    return height;
  }

  slideUp() {
    if (!this.isOpen) {
      return;
    }
    this.element?.classList.remove('open');
    this.plus?.classList.remove('open');
    this.trigger?.element?.classList.remove('open');
    const e = this.content?.element;
    if (e) {
      e.style.height = `${this.getHeight()}px`;
    }
    anime({
      complete: () => {
        this.isOpen = false;
      },
      duration: 300,
      easing: 'easeOutCubic',
      height: 0,
      targets: this.content?.element,
    });
  }

  slideDown() {
    this.element?.classList.add('open');
    this.plus?.classList.add('open');
    this.trigger?.element?.classList.add('open');
    anime({
      complete: () => {
        this.isOpen = true;
        if (this.content?.element) {
          const e = this.content.element;
          e.style.height = 'auto';
        }
      },
      duration: 300,
      easing: 'easeOutCubic',
      height: this.getHeight(),
      targets: this.content?.element,
    });
  }

  clearHandle() {
    this.trigger?.removeAllEventListeners('click');
  }
}
